import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { DocumentUploadContext } from "@shared-kernel/application/ports/shared/document-upload-provider";

type UploadDocumentPayload = DocumentUploadContext & { document: File };

export const uploadDocument = createAsyncThunk<string, UploadDocumentPayload, { extra: Partial<Dependencies> }>(
  "documents/uploadDocument",
  async (payload, { extra: { documentUploadProvider } }) => {
    const { document, ...context } = payload;
    return documentUploadProvider!.uploadDocument(document, context);
  },
);

export const resetUploadDocument = createAction("documents/resetUploadDocument");
